<div class="flex flex-col gap-[16px] justify-start items-start">
  <h2 *ngIf="!isHeaderInside">{{ header }}</h2>

  <div class="container flex flex-col justify-start items-start">
    <h2 *ngIf="isHeaderInside">{{ header }}</h2>

    <div
      class="flex flex-row gap-[8px] justify-center items-start w-full min-w-full h-full min-h-full"
    >
      <mat-icon>error</mat-icon>
      <vi-text>
        {{ 'ACTIVE_ERROR_DETAILS_PAGE.LEGACY_DEVICE_NOTE' | translate }}
      </vi-text>
    </div>
  </div>
</div>
